import { DIALER_METRICS } from '../componentKeys.js'

const identifiers = {
  key: 'keypressLag',
  type: 'dataDog',
}

const formatting = {
  format: {
    title: 'Keypress Lag',
  },
}

const keys = {
  componentKeys: [DIALER_METRICS],
  healthKey: 'performance_health',
}

const keypressLag = {
  metaData: Object.assign(identifiers, formatting, keys),
}

export { keypressLag }
